/*
 * 电视墙服务器
 */
import React from 'react';
import cn from 'classnames';
import Scheme from 'components/product/scheme';
import Contact from 'components/contact';
import Wrapper from 'components/product/relevance/wrapper';
import MultipleBanner from 'components/product/banner/multiple';
import style from './index.module.scss';

const IMG_PRE = 'https://sdk-source.xylink.com/website/assets/hardware/cloud/TVwall/';
const scene = [
  {
    title: '政府大型会议室/应急指挥中心',
    pcUrl: IMG_PRE + 'scene-img0.jpg',
  },
  {
    title: '日常调度/客户参观/样板展示',
    pcUrl: IMG_PRE + 'scene-img1.jpg',
  },
  {
    title: '教学巡课/远程监考/沉浸式互动教学',
    pcUrl: IMG_PRE + 'scene-img2.jpg',
  },
  {
    title: '活动直播/电视台演播室场外连线',
    pcUrl: IMG_PRE + 'scene-img3.jpg',
  },
];
const bannerList = [
  {
    title: '电视墙服务器',
    pcUrl: 'bg0.jpg',
    mUrl: 'm/bg0.jpg',
    desc: '多方会场、监控视频、单兵和无人机等海量画面一屏统览\n实时统一调度，终端无缝融合，轻松掌握全局',
    mDesc: '多方会场、监控视频、单兵和无人机等海量画\n面一屏统览\n实时统一调度，终端无缝融合，轻松掌握全局',
    type: 4,
    className: style.firstBanner,
  },
  {
    title: '海量画面，一览无余',
    pcUrl: 'bg1.jpg',
    mUrl: 'm/bg1.jpg',
    desc: '支持视频会议、监控、智能眼镜、单兵终端、无人机等\n智能终端画面解码上墙',
    mDesc: '支持视频会议、监控、智能眼镜、单兵终端、\n无人机等智能终端画面解码上墙',
    type: 3,
    className: style.banner1,
  },
  {
    title: '至臻高清，自由布局',
    pcUrl: 'bg2.jpg',
    mUrl: 'm/bg2.jpg',
    desc: '高清解码能力，画面清晰\n可调整画面布局，场景预览一键自由切换',
    mDesc: '',
    type: 4,
  },
  {
    title: '集控管理，运筹帷幄',
    pcUrl: 'bg3.jpg',
    mUrl: 'm/bg3.jpg',
    desc: '配置简单，联网即用\n通过统一界面操作，轻松进行实时监看、指挥和调度',
    mDesc: '配置简单，联网即用\n通过统一界面操作，轻松进行实时监看、指挥\n和调度',
    type: 3,
    className: style.banner2,
  },
  {
    title: '超强适应，无惧环境',
    pcUrl: 'bg4.jpg',
    mUrl: 'm/bg4.jpg',
    desc: 'SVC柔性编解码，超强网络抗丢包\n适应复杂网络环境，全面保障产品高可用',
    type: 4,
  },
  {
    title: '灵活扩展，升级无忧',
    pcUrl: 'bg5.jpg',
    mUrl: 'm/bg5.jpg',
    desc: '支持多台堆叠，可匹配业务需求扩展系统容量',
    type: 3,
    className: style.banner3,
  },
];
const TVwall = () => {
  return (
    <Wrapper title="电视墙服务器" menuIndex="2" current={6} customClass={style.tvWall}>
      {bannerList.map((item: any) => {
        return <MultipleBanner {...item} animate={'fadeIn'} delay={0.5} descCenter key={item.title} imageHost={IMG_PRE} className={cn(style.banner, item.className)} />;
      })}
      <Scheme animate="fadeIn" delay={0.5} data={scene} title={'应用场景'} className={style.scene} />
      <Contact className={style.contact} btnType={'newBtn'} />
    </Wrapper>
  );
};

export default TVwall;
